module.exports = __webpack_public_path__ + "static/img/top.2542f28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top.png
// module id = LP6M
// module chunks = 1